import Markdown from "react-markdown";

export default function MarkdownComp({ content, className = "p-0" }) {
  return (
    <Markdown
      data-overlay-light="10"
      className={`max-w-[1440px] w-full mx-auto justify-start items-start ${className}`}
      components={{
        h1: ({ node, ...props }) => {
          return <h1 {...props} className="mb-4 text-4xl font-bold" />; // Use Tailwind CSS typography classes
        },
        h2: ({ node, ...props }) => {
          return (
            <h2
              {...props}
              className="mt-4 mb-4 text-2xl font-bold text-justify"
            />
          ); // Use Tailwind CSS typography classes
        },
        h3: ({ node, ...props }) => {
          return (
            <h3
              {...props}
              className="mt-4 mb-4 text-xl font-bold text-justify"
            />
          ); // Use Tailwind CSS typography classes
        },
        p: ({ node, ...props }) => {
          return <p {...props} className="mb-4 text-justify text-base" />;
        },
        li: ({ node, ...props }) => {
          return <li {...props} className="mb-2 text-justify text-base" />;
        },
      }}
    >
      {content}
    </Markdown>
  );
}
